import {
  ActionAddAvailableRack,
  ActionDeleteAvailableRack,
  ActionEditAvailableRack,
  ActionSetAvailableRacks,
  ActionTypesAvailableRacks,
  IAvailableRack,
} from "./actionTypes";

export const setAvailableRacks = (
  payload: IAvailableRack[]
): ActionSetAvailableRacks => {
  return {
    type: ActionTypesAvailableRacks.SET_AVAILABLE_RACKS,
    payload,
  };
};

export const deleteAvailableRack = (
  payload: string
): ActionDeleteAvailableRack => {
  return {
    type: ActionTypesAvailableRacks.DELETE_AVAILABLE_RACK,
    payload,
  };
};

export const editAvailableRack = (
  payload: IAvailableRack
): ActionEditAvailableRack => {
  return {
    type: ActionTypesAvailableRacks.EDIT_AVAILABLE_RACK,
    payload,
  };
};

export const addAvailableRack = (
  payload: IAvailableRack
): ActionAddAvailableRack => {
  return {
    type: ActionTypesAvailableRacks.ADD_AVAILABLE_RACK,
    payload,
  };
};
